import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import {
    EditorSmartBannersRateCorrectionCondition,
    RateControlValue,
    RateCorrectionConditionId,
    RateCorrectionType
} from '../../../typings/ratesCorrections';
import { RateControl } from '../../RateControl/RateControl';

import './RatesCorrectionsListSmartBannersCondition.css';
import * as keyset from './RatesCorrectionsListSmartBannersCondition.i18n';

const i18n = i18nFactory(keyset);

export type onChangeSmartBannersConditionParams = {
    type: RateCorrectionType.smartBanners;
    value: EditorSmartBannersRateCorrectionCondition;
    id: RateCorrectionConditionId;
};

export interface RatesCorrectionsListSmartBannersConditionProps {
    value: EditorSmartBannersRateCorrectionCondition;
    maxRate?: number;
    minRate?: number;
    isDisabled: boolean;
    onChange: (params: onChangeSmartBannersConditionParams) => void;
}

const blockClass = 'rates-corrections-list-smart-banners-condition';

export class RatesCorrectionsListSmartBannersCondition extends React.PureComponent<
    RatesCorrectionsListSmartBannersConditionProps
> {
    render() {
        const { isDisabled, minRate, maxRate, value } = this.props;

        return (
            <div className={blockClass}>
                {i18n('button-text')}

                <RateControl
                    value={value.value}
                    max={maxRate}
                    min={minRate}
                    isDisabled={isDisabled}
                    isCommon={false}
                    errors={value.errors.value}
                    onChange={this.onRateControlChange}
                />
            </div>
        );
    }

    private onRateControlChange = (rate: RateControlValue) => {
        const { value, onChange } = this.props;

        onChange({
            type: RateCorrectionType.smartBanners,
            id: value.id,
            value: {
                ...value,
                value: rate
            }
        });
    };
}
